<template>
    <div>
      <MyHeader></MyHeader>
      <div class="layout">
        <Layout :style="{minHeight: 'calc(100vh - 64px)', width: '100%'}">
          <Sider hide-trigger :style="{background: '#fff'}" class="slide-dis">
            <Menu ref="menu" :active-name="1-cursel" theme="light" width="auto" :class="menuitemClasses">
              <MenuItem :accordion="true" v-for="(val, key) in tablist" :name="1-key" :key="key"  @click.native="btnclick(key)">
                <span>{{ val }}</span>
              </MenuItem>
            </Menu>
        </Sider>
        <Layout>
            <Content :style="{padding: '8px'}">
                <Card>
                  <BDIndex v-show="cursel == 0" id="goods0"></BDIndex>
                  <JLIndex v-show="cursel == 0" id="goods1"></JLIndex>
                </Card>
            </Content>
        </Layout>
      </Layout>
    </div>
    </div>
</template>
<script>
import MyHeader from './header'
import BDIndex from './introduce/baiduindex.vue'
import JLIndex from './introduce/juliangindex.vue'

export default {
  components: {
    MyHeader,
    BDIndex,
    JLIndex
  },

  data () {
    return {
      isCollapsed: false,
      tablist: ['百度指数工具', '抖音指数工具'],
      tabsel: {},
      cursel: 0
    }
  },
  mounted () {
  },
  computed: {
    menuitemClasses: function () {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    }
  },
  methods: {
    test () {
    },
    btnclick (idx) {
      // this.tabsel[this.$store.curKrid] = idx
      var selector = '#goods' + idx
      console.log('btnclick', selector)

      var anchor = this.$el.querySelector(selector)
      document.documentElement.scrollTop = anchor.offsetTop
    }
  }
}
</script>
<style lang="less" scoped>
    .layout-con{
        height: 100%;
        width: 100%;
    }
    li {
      text-align: left;
    }
    .ivu-menu-item {
      text-align: left;
    }
    .menu-item span{
        display: inline-block;
        overflow: hidden;
        font-weight: 500;
        // width: 69px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
    }
    .menu-item i{
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 16px;
    }
    .collapsed-menu span{
        width: 0px;
        transition: width .2s ease;
    }
    .collapsed-menu i{
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 22px;
    }
    .dev-run-preview .dev-run-preview-edit{ display: none }
    .ivu-layout-sider {
      background-color: white;
    }
    .ivu-layout-sider-trigger{
      background: white;
    }
    .h-btn {
      margin-right: 10px;
    }
    .h-btn-act {
      background-color: #F59A23;
    }
    .slide-dis {
      position: relative;
    }
    @media (max-width: 768px){
      .slide-dis {
        display: none;
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/intr_goods.vue